import { isConsumer } from 'src/config'
import Model from 'src/models/model'
import { buildCheckoutChildRoutes } from 'src/modules/checkout/routes'
import { addMissingCurrentSitePathPrefix, switchToRequiredSite, switchToRootPrimarySiteIfForced } from 'src/router/guards'
import { prependWithConsumerRoot } from 'src/router/utils'

export default async ({ router, store, app }) => {
  if (!isConsumer) return

  await Model.configuration.ensureLoaded()

  // Assumes the currentSite at boot time matches config.siteId
  const defaultSite = Model.configuration.currentSite
  const isHostnameSharedAcrossSites = defaultSite.isHostnameSharedAcrossSites
  const sharedDomainSitesByPath = defaultSite.sharedHostnameSiteIdsByPath

  /**
   * Set checkout routes
   */

  const CheckoutLayout = () => import('src/modules/checkout/layouts/CheckoutLayout.vue')

  // Helper function to build same set of consumer routes multiple times, for the default
  // site and for any other sites that share the same hostname
  function buildNamespacedRootRoute (namespace, siteId, siteRootPath) {
    const isForDefaultRootPath = namespace === 'checkout'

    // All child routes are added as nested subpaths of the '/checkout' root path.
    const rootRoute = {
      name: `${namespace}:root`,
      path: isForDefaultRootPath ? '/checkout' : prependWithConsumerRoot(`${siteRootPath}/checkout`),
      component: CheckoutLayout,
      meta: {},
      children: buildCheckoutChildRoutes(namespace)
    }

    if (isConsumer && isHostnameSharedAcrossSites) {
      // `meta.requiredSiteId` is used by the `switchToRequiredSite` guard to determine which site to switch to
      // when the user navigates to this route and its child routes.
      rootRoute.meta.requiredSiteId = siteId

      const validateSiteGuards = _([
        switchToRootPrimarySiteIfForced,
        addMissingCurrentSitePathPrefix,
        switchToRequiredSite
      ]).flatten().compact().value()

      if (!isForDefaultRootPath) {
        rootRoute.beforeEnter = validateSiteGuards
      }

      _.each(rootRoute.children, route => {
        route.beforeEnter = _([validateSiteGuards, route.beforeEnter]).flatten().compact().value()
      })
    }

    return rootRoute
  }

  router.addRoute(buildNamespacedRootRoute('checkout', defaultSite.id, '/'))

  if (isConsumer && isHostnameSharedAcrossSites) {
    _.each(sharedDomainSitesByPath, (siteId, siteRootPath) => {
      router.addRoute(buildNamespacedRootRoute(`checkout:site-${siteId}`, siteId, siteRootPath))
    })
  }
}
